import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentLoaderService } from './environment-loader.service';
import { ImitationSession } from '../../features/organization/components/imitate-organization-modal/imitation-session-model';

@Injectable({
  providedIn: 'root',
})
export class ImitationSessionService {
  private http = inject(HttpClient);
  private environmentLoaderService = inject(EnvironmentLoaderService);

  apiUrl: string;
  apiUrlAutomation = '';

  constructor() {
    this.apiUrl = this.environmentLoaderService.config['serviceBaseUrl'];
  }

  startImitationSession(organizationId: number): Observable<ImitationSession> {
    const url = this.apiUrl + '/api/v1/admin/imitation-sessions/start';
    return this.http.post<ImitationSession>(url, { organizationId });
  }

  endImitationSession(): Observable<ImitationSession> {
    const url = this.apiUrl + '/api/v1/admin/imitation-sessions/end';
    return this.http.patch<ImitationSession>(url, null);
  }
}
